import { ApolloCache, DocumentNode, gql } from '@apollo/client';

import { UseUpdateCacheOnPostNotVisible_PostV2Fragment } from './graphql-types/UseUpdateCacheOnPostNotVisible_PostV2Fragment';

const POSTV2_FRAGMENT = gql`
  fragment UseUpdateCacheOnPostNotVisible_PostV2Fragment on PostV2 {
    _id
  }
`;

type WithFragment = { postFragment: DocumentNode };
type UseUpdateCacheOnPostNotVisible = () => {
  updateCacheOnPostNotVisible: UpdateCacheOnPostNotVisibleMethod;
};
type UpdateCacheOnPostNotVisibleMethod = (options: {
  cache: ApolloCache<any>;
  post: UseUpdateCacheOnPostNotVisible_PostV2Fragment;
}) => void;

export const useUpdateCacheOnPostNotVisible: UseUpdateCacheOnPostNotVisible &
  WithFragment = (): {
  updateCacheOnPostNotVisible: UpdateCacheOnPostNotVisibleMethod;
} => {
  const updateCacheOnPostNotVisible: UpdateCacheOnPostNotVisibleMethod = ({
    cache,
    post,
  }) => {
    // This client only queries for `PostV2`, but Apollo cache entries contain `Post` prefixes sometimes.
    cache.evict({ id: cache.identify({ id: post._id, __typename: 'Post' }) });
    cache.evict({ id: cache.identify({ id: post._id, __typename: 'PostV2' }) });
    cache.evict({
      id: cache.identify({ id: post._id, __typename: 'SimplePost' }),
    });
    cache.evict({ id: cache.identify({ id: post._id, __typename: 'BlogV2' }) });
    cache.evict({ id: cache.identify({ id: post._id, __typename: 'PollV2' }) });
    cache.evict({
      id: cache.identify({ id: post._id, __typename: 'QuestionV2' }),
    });
    cache.evict({
      id: cache.identify({ id: post._id, __typename: 'AnswerV2' }),
    });
    cache.evict({
      id: cache.identify({ id: post._id, __typename: 'EventAlert' }),
    });
    cache.gc();
  };

  return { updateCacheOnPostNotVisible };
};

useUpdateCacheOnPostNotVisible.postFragment = POSTV2_FRAGMENT;
